import React, { useState } from 'react';
import { ref, push } from 'firebase/database';
import { db } from './firebase-config';
import './NewsletterSignup.css';

function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Create newsletter subscription object
      const subscriptionData = {
        email,
        subscribedAt: new Date().toISOString(),
        active: true
      };
      
      // Save to Firebase database
      await push(ref(db, 'newsletter_subscribers'), subscriptionData);
      
      // Update UI state
      setStatus('success');
      setEmail('');
      console.log('Newsletter subscription saved successfully');
    } catch (error) {
      console.error('Error saving newsletter subscription:', error);
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="newsletter-signup">
      <h4 className="newsletter-signup__title">Subscribe to Newsletter</h4>
      <p className="newsletter-signup__description">
        Get updates about new artists and events
      </p>
      
      <form className="newsletter-signup__form" onSubmit={handleSubmit}>
        <div className="newsletter-signup__input-group">
          <input
            type="email"
            className={`newsletter-signup__input ${status ? `newsletter-signup__input--${status}` : ''}`}
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isSubmitting || status === 'success'}
            required
          />
          <button 
            type="submit" 
            className="newsletter-signup__button"
            disabled={isSubmitting || status === 'success'}
          >
            {isSubmitting ? 'Sending...' : 'Subscribe'}
          </button>
        </div>
        
        {status === 'error' && (
          <p className="newsletter-signup__message newsletter-signup__message--error">
            Please enter a valid email address.
          </p>
        )}
        
        {status === 'success' && (
          <p className="newsletter-signup__message newsletter-signup__message--success">
            Thank you for subscribing!
          </p>
        )}
      </form>
      
      <p className="newsletter-signup__privacy">
        We respect your privacy. You can unsubscribe at any time.
      </p>
    </div>
  );
}

export default NewsletterSignup; 